import { DynamicFormControlLayout, DynamicFormValueControlModel, DynamicFormValueControlModelConfig, serializable } from '@ng-dynamic-forms/core';
import { AnyFormControlModel } from '../shared-models/any-form-control.model';

export const TYPE_DATA_ARRAY = 'DATA_ARRAY';

export interface DataArrayModelConfig<T = any> extends DynamicFormValueControlModelConfig<T[]> {
  addButtonLabel?: string;
  editable?: boolean;
  groupPrototype?: AnyFormControlModel[];
}

export class DataArrayModel<T = any> extends DynamicFormValueControlModel<T[]> {
  @serializable() readonly type: string = TYPE_DATA_ARRAY;
  @serializable() addButtonLabel: string;
  @serializable() editable: boolean;
  @serializable() groupPrototype: AnyFormControlModel[];

  constructor(config: DataArrayModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);

    this.addButtonLabel = config.addButtonLabel || 'Hinzufügen';
    this.editable = config.editable || false;
    this.groupPrototype = config.groupPrototype || [];
  }
}
